<template>
  <div class="terms-conditions-modal">
    <div class="terms-conditions-modal__warning-head" data-ui="terms-conditions-head">
      Warning: Please read carefully before accepting.
    </div>
    <div data-ui="terms-conditions-body" v-html="termsText" />
    <p class="terms-conditions-modal__warning-foot" data-ui="terms-conditions-foot">
      Click to accept the Terms and Conditions and place item in your shopping cart.
    </p>
    <cdr-button class="terms-conditions-modal__accept" data-ui="terms-conditions-accept" @click="$emit('acceptTerms')">
      Accept
    </cdr-button>
    <cdr-button modifier="secondary" data-ui="terms-conditions-cancel" @click="$emit('declineTerms')">
      Cancel
    </cdr-button>
  </div>
</template>

<script>
import { CdrButton } from '@rei/cedar';

export default {
  name: 'TermsAndConditionsModal',
  components: { CdrButton },
  props: {
    termsText: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.terms-conditions-modal {
  padding-bottom: $cdr-space-one-and-a-half-x;
  &__warning-head {
    @extend %cdr-text-body-strong-300;
    margin-bottom: $cdr-space-three-quarter-x;
  }
  &__warning-foot {
    margin-bottom: $cdr-space-one-and-a-half-x;
  }
  &__accept {
    margin-right: $cdr-space-one-x;
  }
}
</style>
